import { useSelector } from 'react-redux';
import { selectApiToken } from './loginSelectors'

export function useToken () {
    return useSelector(selectApiToken) ?? "";
}
